<template>
  <div :class="$style.container">
    <slot name="content" :class="$style.content" />
    <slot name="function" />
  </div>
</template>

<script>
export default {
  name: 'EmptyState'
}
</script>

<style module>
.container {
  padding: 30px 0 30px;
  text-align: center;
  font-size: 1.3rem;
}
</style>
